import { Modal, Select } from "@mantine/core";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { TextAreaInput, TextInput } from "../UI/FormField";
import { BiLoaderAlt } from "react-icons/bi";
import { SingleImageUploader } from "../UI/ImageHandler";

const SMS_TEMPLATE_KEYS = [
  { value: "order-placed-confirmation", label: "Order Confirmation" },
  { value: "order-processing-staging", label: "Order Processing" },
  { value: "order-delivering-staging", label: "Order Delivering" },
  { value: "order-delivered-staging", label: "Order Delivered" },
  { value: "order-cancellation", label: "Order Cancellation" },
  { value: "review-request", label: "Review Request" },
  { value: "subscription-confirmation", label: "Subscription Confirmation" },
];

const SMSTemplateAddModal = ({
  opened,
  setOpened,
  handleSubmit,
  loading,
  existingKeys = [],
}) => {
  const initialValues = {
    key: "",
    message: "",
  };

  const validationSchema = Yup.object({
    key: Yup.string()
      .required("Key is required")
      .notOneOf(existingKeys, "Key already exists"),
    message: Yup.string().required("Message is required"),
  });

  const availableKeys = SMS_TEMPLATE_KEYS.filter(
    (k) => !existingKeys.includes(k.value),
  );

  return (
    <Modal
      opened={opened}
      onClose={() => setOpened(false)}
      title='Add SMS Template'
      centered
      size='lg'
    >
      <div className=' max-h-96 overflow-y-auto  py-5'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form className='space-y-4'>
              <SingleImageUploader
                title='Media Image'
                values={values}
                field={"mediaUrl"}
                setFieldValue={setFieldValue}
              />
              <div>
                <label className='block mb-1 font-medium'>Template Key</label>
                <Select
                  placeholder='Select template key'
                  data={availableKeys}
                  value={values.key}
                  onChange={(value) => setFieldValue("key", value)}
                  error={touched.key && errors.key}
                  searchable
                  clearable
                />
              </div>

              <TextAreaInput
                name='message'
                label='Message'
                maxLength={250}
                placeholder='Enter SMS message'
                className='block w-full h-[150px] rounded-md border px-3 py-2'
              />

              <button
                type='submit'
                disabled={loading}
                className='w-full bg-red-600 text-white py-2 rounded-md'
              >
                {loading ? (
                  <BiLoaderAlt className='animate-spin text-2xl m-auto' />
                ) : (
                  "Add Template"
                )}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default SMSTemplateAddModal;
